import './briefe.css';
import { useNavigate } from 'react-router-dom';
import { fmtDayMonth } from '../../lib/format';
import { useApi } from '../../lib/useApi';
import { Bar, type Row } from '../lohn/LohnBar';
import { AREA_LABEL, duePill, letterPath } from './labels';
import type { BriefeBarResponse } from './types';

// Leiste „Briefe vom Mandanten“: offene Briefe meiner Bereiche (knappste Frist oben), bis jemand „Erledigt“ setzt.
// Erledigte erscheinen wieder, wenn der Mandant danach kommentiert. Ohne clientId alle Mandanten, sonst nur dieser.
export function BriefeBar({ clientId }: { clientId?: string }) {
  const navigate = useNavigate();
  const res = useApi<BriefeBarResponse>(`/api/kanzlei/briefe${clientId ? `?clientId=${clientId}` : ''}`, {
    live: ['briefe'],
  });
  const d = res.data;
  if (!d?.items.length) return null;

  const rows: Row[] = d.items.map((l) => {
    const pill = l.due ? duePill(l.due) : null;
    return {
      key: l.id,
      go: () => navigate(letterPath(l.clientId, l.id)),
      tx: (
        <>
          <b>{l.sender}</b>
          {!clientId && ` · ${l.clientName}`}
          {d.admin && l.who !== undefined && (
            <span className={`note${l.who ? '' : ' who-open'}`}>
              {' '}
              · {AREA_LABEL[l.area]}: {l.who ?? 'offen, bitte zuweisen'}
            </span>
          )}
          {l.unseen && (
            <>
              {' '}
              <span className="pill p-info">neu</span>
            </>
          )}
          {l.newComment && (
            <>
              {' '}
              <span className="pill p-warn">💬 neuer Kommentar</span>
            </>
          )}
          {pill && (
            <>
              {' '}
              <span className={`pill p-${pill.tone}`}>{pill.label}</span>
            </>
          )}
          {l.kiBetreff && <small className="ki-b">✨ {l.kiBetreff}</small>}
          <small>
            📄 {l.name} · {l.fromOffice ? 'eingescannt' : 'hochgeladen'} am {fmtDayMonth(l.createdAt)}
            {l.createdBy ? ` von ${l.createdBy}` : ''}
            {l.status === 'erledigt' && ' · schon erledigt'}
          </small>
        </>
      ),
    };
  });
  return (
    <Bar
      head={`✉ ${rows.length === 1 ? 'Brief vom Mandanten' : `${rows.length} Briefe vom Mandanten`}`}
      rows={rows}
      className="briefbar"
    />
  );
}
